import React from 'react';

import ProductsOnBackOrder from './ProductsOnBackOrder.jsx';

function ProductsOnBackOrderPage() {
  return <ProductsOnBackOrder />;
}

export default React.memo(ProductsOnBackOrderPage);
